export default "__VITE_ASSET__DClldNqv__"